/**
 * VH-253: one field, at the top, always.
 *
 * Typed standing in the kitchen: "Milch 2 l", Enter, done. There is deliberately no
 * separate amount field — the backend's parse rules already split "Frischkäse 1000 g"
 * into a name and an amount, and a second field would be a second tap for the same
 * information.
 */

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PlusIcon } from '@heroicons/react/24/outline'

export default function AddItem({ onAdd, pending = false }) {
  const { t } = useTranslation()
  const [value, setValue] = useState('')

  const submit = async (event) => {
    event.preventDefault()
    const trimmed = value.trim()
    if (!trimmed) return
    const ok = await onAdd(trimmed)
    if (ok !== false) setValue('')
  }

  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="shopping-add-form">
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('shopping.add.placeholder')}
        aria-label={t('shopping.add.aria')}
        maxLength={200}
        enterKeyHint="done"
        className="input flex-1 min-h-[44px]"
        data-testid="shopping-add-input"
      />
      <button
        type="submit"
        className="btn-primary min-h-[44px] px-4"
        disabled={pending || !value.trim()}
        aria-label={t('shopping.add.button')}
        data-testid="shopping-add-submit"
      >
        <PlusIcon className="h-5 w-5" aria-hidden="true" />
      </button>
    </form>
  )
}
